<template>
  <b-container>
    <Headline title="Followers"></Headline>

    <b-row>
      <b-col class="list">
        <div class="fan" v-for="fan in followers" :key="fan.id">
          <router-link class="name" :to="{name: 'fan-profile', params: {id: fan.id}}"><img :src="avatarImage(fan)"></router-link>
          <router-link class="name" :to="{name: 'fan-profile', params: {id: fan.id}}">{{ displayName(fan) }}</router-link>
        </div>
      </b-col>
    </b-row>

  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .container {
    margin-top: 1em;
  }

  .list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    @include media-breakpoint-up(sm) {
      justify-content: left;
    }

    .fan {
      width: 10em;
      margin-top: 1em;
      margin-right: 1em;
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        display: block;
        width: 96px;
        height: 96px;
        border-radius: 100%;
        margin-bottom: 5px;
      }

      .name {
        color: $white;
        font-weight: bold;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
</style>

<script>
import Headline from '@/components/widgets/Headline'

import { profileHelpers } from '@/store/helpers'

export default {
  name: 'Followers',
  components: {
    Headline
  },
  data () {
    return {
      followers: []
    }
  },
  created () {
    this.initPage()
  },
  watch: {
    '$route': 'initPage'
  },
  methods: {
    async initPage () {
      const followers = await this.$store.dispatch('profile/listFollowers')
      this.followers = await followers.all()
    },
    ...profileHelpers
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/artist/Followers.vue